import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { loadLanguage } from '@/core/i18nUtils';
import createRouter from './router';
import createStore from './store';

export default (i18n) => {
  Vue.use(VueScrollTo);

  AOS.init();

  const Article = () => import('./main');

  const vue = new Vue({
    el: '#article',
    store: createStore(),
    i18n,
    router: createRouter(),
    data() {
      return {
        loadedI18n: false,
      };
    },
    render(h) {
      if (this.loadedI18n) {
        return h(Article);
      }
      return h('p', '');
    },
    async beforeCreate() {
      await loadLanguage(this, ['main', 'home', 'find', 'article', 'stock_info']);

      switch (window.lang) {
        case 'english':
          this.$i18n.locale = 'en';
          break;
        case 'gb':
          this.$i18n.locale = 'gb';
          break;
        default:
          this.$i18n.locale = 'zh';
      }
      this.loadedI18n = true;
    },
  });

  return vue;
};
